import { Box, Button, ButtonGroup, Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { shippingApiNm } from "./shippingApiNm"
import { addIdForDataGrid } from "utils"
import { expenseColumns, jobOrderColumns, pcItemColumns, subcontractColumns } from "./columnsExpense"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import PettyCashDialog from "pages/Menu1/PettyCash/PettyCashDialog"
// import AddItemTableDialog from "pages/Menu1/PettyCash/AddItemTableDialog"
import { AddRounded, ChevronRightRounded, ReceiptRounded, ViewListRounded } from "resource/muiImport"
import { alertError, alertSuccess } from "components/Alert"
import ExpenseJobOrderDialogV2 from "pages/Menu3/AddJobOrderExpenseV2/ExpenseJobOrderDialogV2"
import { green, red } from "@mui/material/colors"
import { expenseJobOrderApiNm } from "constants/expenseJobOrderConstant"
import { initExpenseJobOrderData } from "components/InvoiceDialogV2/initData"
import AddAdvanceDialog from "pages/Menu1/PettyCash/AddAdvanceDialog"
import { UserContext } from "contexts/UserContext"
import ButtonGroupSelection from "components/ButtonGroupSelection"
import SubcontractExpenseDialog from "pages/Menu3/SubcontractInvoice/SubcontractExpenseDialog"
import { childAbbr } from "branch/constant/shipping/shipping"
import AddExpenseTableDialog from "pages/Menu3/AddJobOrderExpense/AddExpenseTableDialog"
import TextFieldDialog from "components/dialog/TextFieldDialog"

let selectedPCTrnsId = null
let selectedExpJobOrdId = null
let selectedExpJobOrdData = null
let selectedScExpId = null
let joItem = null
let pcViewModeIdLabels = [
  { id: 'Trns', label: 'เงินจ่าย' },
  { id: 'Itms', label: 'ใบเสร็จ' },
]

const ShippingAllExpense = ({ selectedId, dialogOpen, setDialogOpen, onFinish, isChildExp }) => {
  const { user } = useContext(UserContext)
  const { ax } = useContext(GlobalStateContext)
  const [shpData, setShpData] = useState({ JobNo: '', CusSNm: '', JobSNm: '' })
  const [joData, setJoData] = useState([])
  const [scItems, setScItems] = useState([])
  const [pcTrnsData, setPcTrnsData] = useState([])
  const [pcItemData, setPcItemData] = useState([])
  const [expData, setExpData] = useState([])
  const [joSelection, setJOSelection] = useState([])
  const [dialogPettyCashOpen, setDialogPettyCashOpen] = useState(false)
  // const [dialogAddItemTableOpen, setDialogAddItemTableOpen] = useState(false)
  const [dialogAddAdvanceOpen, setDialogAddAdvanceOpen] = useState(false)
  const [dialogExpenseJobOrderOpen, setDialogExpenseJobOrderOpen] = useState(false)
  const [dialogSubcontractExpenseOpen, setDialogSubcontractExpenseOpen] = useState(false)
  const [dialogTextFieldOpen, setDialogTextFieldOpen] = useState(false)
  const [dialogAddExpenseTableOpen, setDialogAddExpenseTableOpen] = useState(false)
  const [pcViewMode, setPCViewMode] = useState('Trns')

  const updLnkSiteAbbr = useMemo(() => {
    if (isChildExp) {
      return childAbbr
    }
    return null
  }, [isChildExp])

  const modPCTrnsData = useMemo(() => {
    return addSumRow({
      dataTable: pcTrnsData.filter(item => joSelection.includes(item.JobOrdId)),
      sumColNms: ['PayAmnt'],
      sumColTotal: 'ExpNm',
    })
  }, [pcTrnsData, joSelection])

  const modScItemData = useMemo(() => {

    return addSumRow({
      dataTable: scItems.filter(item => joSelection.includes(item.JobOrdId)),
      sumColNms: ['Total'],
      sumColTotal: 'ExpNm',
    })
  }, [scItems, joSelection])

  const modPCItemData = useMemo(() => {

    return addSumRow({
      dataTable: pcItemData.filter(item => joSelection.includes(item.JobOrdId)),
      sumColNms: ['PayAmnt'],
      sumColTotal: 'ExpNm',
    })
  }, [pcItemData, joSelection])


  const modExpData = useMemo(() => {
    return addSumRow({
      dataTable: expData.filter(item => joSelection.includes(item.JobOrdId)),
      sumColNms: ['Total'],
      sumColTotal: 'ExpNm',
    })
  }, [expData, joSelection])

  const getData = useCallback(() => {
    const postData = {
      ShpInvId: selectedId,
      isChildExp: isChildExp,
      LnkSiteAbbr: updLnkSiteAbbr
    }
    ax.post(shippingApiNm.getShippingAllExpense, postData).then(value => {
      if (value.data) {
        setShpData(value.data.shpData[0])
        setJoData(addIdForDataGrid(value.data.jobOrders, 'JobOrdId'))
        setPcTrnsData(addIdForDataGrid(value.data.pcTrans, 'PCTrnsId'))
        setPcItemData(addIdForDataGrid(value.data.pcItems, 'PCItmId'))
        setExpData(addIdForDataGrid(value.data.expenses, 'ExpJobOrdId'))
        setScItems(addIdForDataGrid(value.data.scItems, 'ScExpId'))
      }
    })
  }, [ax, selectedId, isChildExp, updLnkSiteAbbr])

  const handlePCItemCellClick = useCallback(({ field, id, row }) => {
    if (field === 'ShowDetail' && id !== 0) {
      selectedPCTrnsId = row.PCTrnsId
      setDialogPettyCashOpen(true)
    } else if (field === 'AddExpense' && pcViewMode === 'Itms' && id !== 0) {
      const argsArr = []
      const row = pcItemData.find(item => item.PCItmId === id)
      if (row) {
        argsArr.push({
          JobOrdId: row.JobOrdId,
          ExpId: row.ExpId,
          UntPr: row.Amnt,
          IsOwnRcpt: 0,
          Qty: 1
        })
        const postData = {
          argsArr: argsArr,
          getArgs: null,
          UpdLnkSiteAbbr: updLnkSiteAbbr
        }
        ax.post(expenseJobOrderApiNm.insertUpdateExpenseJobOrderBulk, postData).then(value => {
          if (value.data) {
            getData()
          }
        })
      }
      console.log("argsArr:", argsArr)
    }
  }, [ax, pcItemData, getData, pcViewMode, updLnkSiteAbbr])

  const handleExpenseCellClick = useCallback(({ id, row, field }) => {
    if (field === 'ShowDetail' && id !== 0) {
      selectedExpJobOrdId = id
      selectedExpJobOrdData = {
        ...row,
        ExpJobOrdIds: [id]
      }
      setDialogExpenseJobOrderOpen(true)
    }
  }, [])

  const handleSubcontractExpenseCellClick = useCallback(({ id, row, field }) => {
    if (field === 'ShowDetail' && id !== 0) {
      selectedExpJobOrdId = id
      selectedExpJobOrdData = {
        ...row,
        ExpJobOrdIds: [id]
      }
      setDialogExpenseJobOrderOpen(true)
    } else if (field === 'AddExpense' && id !== 0) {
      const argsArr = []
      const row = scItems.find(item => item.ScExpId === id)
      if (row) {
        argsArr.push({
          JobOrdId: row.JobOrdId,
          ExpId: row.ExpId,
          UntPr: row.UntPr,
          Qty: row.Qty,
          IsOwnRcpt: row.IsOwnRcpt,
        })
        const postData = {
          argsArr: argsArr,
          getArgs: null,
          UpdLnkSiteAbbr: updLnkSiteAbbr
        }
        ax.post(expenseJobOrderApiNm.insertUpdateExpenseJobOrderBulk, postData).then(value => {
          if (value.data) {
            getData()
          }
        })
      }
    }
  }, [ax, getData, scItems, updLnkSiteAbbr])

  const handleAddAdvance = useCallback(() => {
    if (joSelection.length !== 1) {
      alertError("กรุณาเลือก 1 ใบงาน")
      return
    }
    // setDialogAddItemTableOpen(true)
    joItem = joData.find(item => item.JobOrdId === joSelection[0])
    setDialogAddAdvanceOpen(true)
  }, [joSelection, joData])

  const handleAddExpense = useCallback(() => {
    if (joSelection.length === 0) {
      alertError("กรุณาเลือกใบงานที่ต้องการเพิ่มรายได้")
      return
    }
    selectedExpJobOrdId = null
    selectedExpJobOrdData = {
      ...initExpenseJobOrderData,
      JobOrdId: joSelection[0],
      JobOrdIds: joSelection
    }
    setDialogExpenseJobOrderOpen(true)
  }, [joSelection])

  const onPettyCashDialogFinish = useCallback(() => {
    getData()
  }, [getData])

  const handleUsePCItemAsExpense = useCallback(() => {

    const argsArr = []
    for (const row of pcItemData) {
      if (!row.IsCost) {
        argsArr.push({
          JobOrdId: row.JobOrdId,
          ExpId: row.ExpId,
          UntPr: row.Amnt,
          IsOwnRcpt: 0,
          Qty: 1
        })
      }
    }
    const postData = {
      argsArr: argsArr,
      getArgs: null,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    ax.post(expenseJobOrderApiNm.insertUpdateExpenseJobOrderBulk, postData).then(value => {
      if (value.data) {
        getData()
      }
    })
    console.log("argsArr:", argsArr)
  }, [ax, getData, pcItemData, updLnkSiteAbbr])

  const onExpenseJobOrderDialogFinish = useCallback(async (data) => {
    console.log("onExpenseJobOrderDialogFinish data:", data)
    if (data) {
      // const jobOrdIds = joSelection.length > 0? joSelection: [data.JobOrdId]
      if (data.ExpJobOrdId > 0) {
        if (data.IsDel && data.ExpJobOrdIds && data.ExpJobOrdIds.length > 0) {
          const postData = {
            ExpJobOrdIds: data.ExpJobOrdIds,
            UpdLnkSiteAbbr: updLnkSiteAbbr
          }
          await ax.post(expenseJobOrderApiNm.deleteExpenseJobOrder, postData)
          alertSuccess("ลบข้อมูลเรียบร้อยแล้ว")
        } else {
          const postdata = {
            ...data,
            ExpJobOrdIds: data.ExpJobOrdIds,
            UpdLnkSiteAbbr: updLnkSiteAbbr,
            getArgs: { ExpJobOrdId: data.ExpJobOrdId }
          }
          const value = await ax.post(expenseJobOrderApiNm.updateExpenseJobOrderBulk, postdata)
          if (value.data) {
            alertSuccess("แก้ไขข้อมูลเรียบร้อยแล้ว")
          }
        }
      } else {
        const argsArr = []
        for (const id of joSelection) {
          argsArr.push({
            ...data,
            JobOrdId: id
          })
        }
        const postData = {
          argsArr: argsArr,
          getArgs: null,
          UpdLnkSiteAbbr: updLnkSiteAbbr
        }
        const value = await ax.post(expenseJobOrderApiNm.insertUpdateExpenseJobOrderBulk, postData)
        if (value.data) {
          alertSuccess("บันทึก]ข้อมูลเรียบร้อยแล้ว")
        }
      }
      getData()
    }
  }, [joSelection, ax, getData, updLnkSiteAbbr])

  const handleSetPCViewMode = useCallback((value) => {
    setPCViewMode(value)
  }, [])

  const handleOpenAddExpenseTable = useCallback(() => {
    if (joSelection.length === 0) {
      alertError("กรุณาเลือกใบงานที่ต้องการเพิ่มรายได้")
      return
    }
    setDialogAddExpenseTableOpen(true)
  }, [joSelection])

  const onAddExpenseTableDialgoFinish = useCallback(async (data) => {

    if (!data) return

    console.log("onAddExpenseTableDialgoFinish data:", data)
    const argsArr = []
    for(const id of joSelection) {
      for(const item of data) {
        argsArr.push({
          ...item,
          JobOrdId: id
        })
      }
    }
    const postData = {
      argsArr: argsArr
    }
    ax.post(expenseJobOrderApiNm.insertUpdateExpenseJobOrderBulk, postData).then(value => {
      if (value.data) {
        getData()
      }
    })
  }, [joSelection, ax, getData])

  const handleOpenDialogTextField = useCallback(() => {
    if(joSelection.length === 0) {
      alertError("กรุณาเลือกใบงานที่ต้องการเพิ่มรายได้")
      return
    }
    setDialogTextFieldOpen(true)
  }, [joSelection])

  const handleAddExpenseFromJobNo = useCallback((text) => {
    console.log("handleAddExpenseFromJobNo text:", text)
    const postData = {
      JobNo: text,
      JobOrdIds: joSelection,
    }
    ax.post(shippingApiNm.insertExpenseJobOrderFromJobNo, postData).then(value => {
      if(value.data){
        getData()
      }
    })
  }, [ax, joSelection, getData])

  useEffect(() => {
    if (dialogOpen) {
      getData()
    } else {
      setShpData({ JobNo: '', CusSNm: '', JobSNm: '' })
      setJoData([])
      setScItems([])
      setPcTrnsData([])
      setPcItemData([])
      setJOSelection([])
      selectedPCTrnsId = null
      joItem = {}
    }
  }, [dialogOpen, getData])

  useEffect(() => {
    if (joData && joData.length > 0) {
      setJOSelection([joData[0].id])
    }
  }, [joData])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{ sx: { minWidth: 1700, maxWidth: 1700 } }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ข้อมูลรายได้-ค่าใช้จ่าย"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1 }}>
          <BoxFR>
            <Typography variant="h6" >JobNo: </Typography>
            <Typography variant="h6" color="primary">{shpData.JobNo}</Typography>
          </BoxFR>
          <Box height={250} sx={{ mt: 0 }}>
            <DataGridCellExpand
              checkboxSelection
              selectionModel={joSelection}
              isRowSelectable={(params) => params.id !== 0}
              onSelectionModelChange={(newSelectionModel) => {
                setJOSelection(newSelectionModel);
              }}
              hideFooter
              hideToolbar
              rows={joData}
              columns={jobOrderColumns}
            />
          </Box>
          <BoxFR>

            <BoxFC sx={{ gap: 1, flex: 1 }}>
              <BoxFR>
                <Typography variant="h6" >วางบิลรถร่วม/Supplier</Typography>
                {/* <Button variant="contained" size="small"
                  onClick={handleAddExpense}><AddRounded sx={{ mr: 1 }} />
                  เพิ่มรายได้</Button> */}
              </BoxFR>
              <Box height={280} sx={sxSumColorClass}>
                <DataGridCellExpand

                  disableSelectionOnClick
                  hideFooter
                  hideToolbar
                  rows={modScItemData}
                  columns={subcontractColumns}
                  onCellClick={handleSubcontractExpenseCellClick}
                  getRowClassName={getSumColorClassName}
                  isRowSelectable={(params) => params.id !== 0}
                  experimentalFeatures={{ rowPinning: true }}
                  pinnedRows={{ bottom: [modScItemData.find(row => row.id === 0)] }}
                />
              </Box>
            </BoxFC>
            <BoxFC sx={{ gap: 1, flex: 1.1 }}>
              <BoxFR>
                <Typography variant="h6" >ค่าใช้จ่าย</Typography>
                <ButtonGroupSelection idLables={pcViewModeIdLabels}
                  value={pcViewMode} setValue={handleSetPCViewMode} />
                <Button variant="contained" size="small"
                  onClick={handleAddAdvance}><ReceiptRounded sx={{ mr: 1 }} />
                  เพิ่มเงินล่วงหน้า</Button>
                <Box flex={1} />
                <Button variant="contained" size="small" sx={{ mr: 1 }}
                  onClick={handleUsePCItemAsExpense}>
                  ดึงรายได้ <ChevronRightRounded /></Button>
              </BoxFR>

              <Box height={280} sx={{
                ...sxSumColorClass,
                '& .cost': { bgcolor: red[50] },
                "& .income": { bgcolor: green[50] }
              }}>
                <DataGridCellExpand

                  disableSelectionOnClick
                  hideFooter
                  hideToolbar
                  rows={pcViewMode === "Trns" ? modPCTrnsData : modPCItemData}
                  columns={pcItemColumns}
                  onCellClick={handlePCItemCellClick}
                  getRowClassName={getSumColorClassName}
                  isRowSelectable={(params) => params.id !== 0}
                  experimentalFeatures={{ rowPinning: true }}
                  pinnedRows={{ bottom: [modPCItemData.find(row => row.id === 0)] }}
                />
              </Box>
            </BoxFC>

            <BoxFC sx={{ gap: 1, flex: 1.1 }}>
              <BoxFR>
                <Typography variant="h6" >รายได้</Typography>
                <ButtonGroup>
                  <Button variant="contained" size="small"
                    onClick={handleAddExpense}><AddRounded sx={{ mr: 1 }} />
                    เพิ่มรายได้</Button>
                  <Button variant="contained" size="small"
                    onClick={handleOpenAddExpenseTable}>
                    <ViewListRounded />
                  </Button>
                </ButtonGroup>
                <Box flex={1} />
                <Button variant="contained" size="small" onClick={handleOpenDialogTextField}>
                  เพิ่มรายได้จาก JobNo เดิม
                </Button>
              </BoxFR>
              <Box height={280} sx={sxSumColorClass}>
                <DataGridCellExpand

                  disableSelectionOnClick
                  hideFooter
                  hideToolbar
                  rows={modExpData}
                  columns={expenseColumns}
                  onCellClick={handleExpenseCellClick}
                  getRowClassName={getSumColorClassName}
                  isRowSelectable={(params) => params.id !== 0}
                  experimentalFeatures={{ rowPinning: true }}
                  pinnedRows={{ bottom: [modExpData.find(row => row.id === 0)] }}
                />
              </Box>
            </BoxFC>
            {/* <BoxFC sx={{ gap: 1, flex: 1 }}></BoxFC> */}
          </BoxFR>
          <PettyCashDialog
            updLnkSiteAbbr={updLnkSiteAbbr}
            selectedId={selectedPCTrnsId}
            dialogOpen={dialogPettyCashOpen}
            setDialogOpen={setDialogPettyCashOpen}
            onFinish={onPettyCashDialogFinish}
            lastFilter={null} />
          {/* <ReimbursementDialog
            dialogOpen={dialogReimbursementOpen}
            setDialogOpen={setDialogReimbursementOpen}
            onFinish={onPettyCashDialogFinish}
            joData={joItem}
            usrAccId={null} /> */}
          {/* <AddItemTableDialog
            pcTrnsData={{}}
            JobOrdIds={joSelection}
            dialogOpen={dialogAddItemTableOpen}
            setDialogOpen={setDialogAddItemTableOpen}
            onFinish={onPettyCashDialogFinish}
          /> */}
          <AddAdvanceDialog
            updLnkSiteAbbr={updLnkSiteAbbr}
            pcTrnsId={null}
            dialogOpen={dialogAddAdvanceOpen}
            setDialogOpen={setDialogAddAdvanceOpen}
            onFinish={onPettyCashDialogFinish}
            isFromJobOrder={false}
            usrAccId={user.AccId}
            joData={joItem}
            pcTrnsData={null} />
          <SubcontractExpenseDialog
            updLnkSiteAbbr={updLnkSiteAbbr}
            selectedId={selectedScExpId}
            dialogOpen={dialogSubcontractExpenseOpen}
            lastFilter={null}
            setDialogOpen={setDialogSubcontractExpenseOpen}
            onFinish={onPettyCashDialogFinish} />
          <ExpenseJobOrderDialogV2
            updLnkSiteAbbr={updLnkSiteAbbr}
            dialogOpen={dialogExpenseJobOrderOpen}
            selectedExpJobOrdId={selectedExpJobOrdId}
            setDialogOpen={setDialogExpenseJobOrderOpen}
            onFinish={onExpenseJobOrderDialogFinish}
            expJobOrdData={selectedExpJobOrdData} />

          <AddExpenseTableDialog
            dialogOpen={dialogAddExpenseTableOpen}
            setDialogOpen={setDialogAddExpenseTableOpen}
            onFinish={onAddExpenseTableDialgoFinish}
            jobOrdIds={joSelection}
          />

          <TextFieldDialog 
            title="กรุณาระบุ JobNo"
            label="JobNo"
            dialogOpen={dialogTextFieldOpen}
            setDialogOpen={setDialogTextFieldOpen}
            onFinish={handleAddExpenseFromJobNo}/>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(ShippingAllExpense)